/** @format */
import React, { useState } from "react";

import { apiLogin } from "../../services/auth";
import { notification } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { path, sessionVar, allowedRoles } from "../../utils/common/constant";
import { setSessionVar } from "../../utils/common/hashData";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

import imgbackgroundLogin from "../../assets/About/AboutResponsibility.webp";
// import imgLogo from "../../assets/common/logo.webp";
import imgLogo from "../../assets/common/logo_sunny.webp";

const Login = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    user_password: "",
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleLogin = async () => {
    let newErrors = {};

    if (!formData.email) newErrors.email = t("email_Vlogin");
    else if (!emailRegex.test(formData.email)) {
      newErrors.email = t("email_Regexlogin");
    }

    if (!formData.user_password) newErrors.user_password = t("email_VPassword");
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      await apiLogin(formData)
        .then((res) => {
          if (res.data.status === 200) {
            setSessionVar(sessionVar.user, {
              role: res.data.role,
            });
            // console.log(res.data.data);
            sessionStorage.setItem("name", res.data.data.username);
            setSessionVar(sessionVar.user, {
              name: res.data.data.username,
              email: res.data.data.email,
              role: res.data.data.role,
              pictureUrl: res.data.data.pictureUrl,
            });

            // onSetUser({ role: res.data.role });
            notification.success({
              message: `Login successfully !`,
              placement: "topRight",
              duration: 2,
            });
            navigate("../" + path.private.MANAGEBLOG);
          }
          if (res.data.status === 400) {
            notification.error({
              message: t("error_login"),
              placement: "topRight",
              duration: 2,
            });
            // navigate("../" + path.private.MANAGEBLOG);
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#f7f7f7] ">
      <div className="w-[90%] max-w-[1200px] bg-white shadow-lg grid grid-cols-2 pv:max-md:grid-cols-1">
        {/* Left Section */}
        <div className="w-full  pv:max-md:hidden">
          <img
            className="h-full w-full rounded-l-xl  "
            src={imgbackgroundLogin}
          ></img>
        </div>

        {/* Right Section */}
        <div className="w-full  bg-white p-10 flex flex-col justify-center rounded-r-xl">
          <div className="w-full ">
            <div className="pb-10 flex justify-center">
              <img className="h-[100px] w-[120px]" src={imgLogo}></img>
            </div>
            <div className="mb-4">
              <label
                className="block text-primary text-sm font-bold mb-2"
                htmlFor="email"
              >
                {t("login_email")}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  })
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}
                className={`w-full px-3 py-2 border ${errors.email ? "border-red-500" : "border-gray-300"} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500`}
                placeholder={t("login_placeholderemail")}
              />
              {errors.email && (
                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
              )}
            </div>

            <div className="mb-6 relative">
              <label
                className="block text-primary text-sm font-bold mb-2"
                htmlFor="password"
              >
                {t("login_password")} <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={formData.user_password}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      user_password: e.target.value,
                    })
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleLogin();
                    }
                  }}
                  className={`w-full px-3 py-2 border ${errors.user_password ? "border-red-500" : "border-gray-300"} rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-10`}
                  placeholder={t("login_placeholderpassword")}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <Icon
                      icon={"formkit:hidden"}
                      className="w-6 h-6 text-gray-500"
                    />
                  ) : (
                    <Icon
                      icon={"mdi:show-outline"}
                      className="w-6 h-6 text-gray-500"
                    />
                  )}
                </button>
              </div>
              {errors.user_password && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.user_password}
                </p>
              )}
            </div>

            <div className="flex items-center justify-center">
              <button
                onClick={() => {
                  handleLogin();
                }}
                className="w-full bg-gradient-to-r bg-secondary1 text-white py-2 rounded-lg"
              >
                {t("login_button")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
